
// Section srolling promotion

class ScrollingPromotion extends HTMLElement {
  constructor() {
    super();

    this.config = {
      moveTime: parseFloat(this.dataset.speed), // 100px going to move for
      space: 100, // 100px
    };

    this.promotion = this.querySelector('.promotion');

    this.init();
  }

  init() {
    if (this.childElementCount === 1) {
      this.promotion.classList.add('promotion--animated');

      for (let index = 0; index < 10; index++) {
        this.clone = this.promotion.cloneNode(true);
        this.clone.setAttribute('aria-hidden', true);
        this.appendChild(this.clone);

        const imageWrapper = this.clone.querySelector('.media-wrapper');
        if (imageWrapper) {
          imageWrapper.classList.remove('loading');
        }
      }

      const animationTimeFrame = (this.promotion.clientWidth / this.config.space) * this.config.moveTime;
      this.style.setProperty('--duration', `${animationTimeFrame}s`);

      // pause when out of view
      const observer = new IntersectionObserver((entries, _observer) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            this.scrollingPlay();
          } else {
            this.scrollingPause();
          }
        });
      }, {rootMargin: '0px 0px 50px 0px'});

      observer.observe(this);
    }
  }

  scrollingPlay() {
    this.classList.remove('scrolling-promotion--paused');
  }

  scrollingPause() {
    this.classList.add('scrolling-promotion--paused');
  }
}
customElements.define('scrolling-promotion', ScrollingPromotion);


// Returns boolean if param is scrolled into view

const isScrolledIntoView = (el) => {
  var rect = el.getBoundingClientRect();
  var elemTop = rect.top;
  var elemBottom = rect.bottom;
  // Only completely visible elements return true:
  // var isVisible = (elemTop >= 0) && (elemBottom <= window.innerHeight);
  // Partially visible elements return true:
  isVisible = elemTop < window.innerHeight && elemBottom >= 0;
  return isVisible;
}

const isMobile = () => {
  if (window.matchMedia('(any-hover: none)').matches || document.documentElement.clientWidth < 768) {
    return true;
  }
  return false;
};

// Add class to the section scrolled into view

const initSectionAnimation = () => {
  document.querySelectorAll('.animation-section').forEach((section) => {
    if(isScrolledIntoView(section)) {
      section.classList.add('animate');
    }
  })
}

// Init comparison section

const initComparisonSection = () => {
  const section = document.querySelector('.section-comparison');

  if(!section) return;

  const comparison = document.querySelector('.comparison-image');
  const comparisonAfter = comparison.querySelector('.comparison-image--after');
  const comparisonAxis = comparison.querySelector('.comparison-axis');
  const comparisonInfoLeft = document.querySelector('.comparison-info.left');
  const comparisonInfoRight = document.querySelector('.comparison-info.right');

  let scrollY = window.scrollY;
  let windowHeight = window.innerHeight;
  let position = section.offsetTop + comparison.offsetTop;

  let offset = 150;

  let startPos = position - windowHeight + comparison.offsetHeight - offset;
  let endPos = position;
  let percent = (scrollY - startPos) / (endPos - startPos);

  if(scrollY >= startPos && scrollY <= endPos) {
    comparisonAfter.style.clipPath = `polygon(${100 - percent * 100}% 0, 100% 0, 100% 100%, ${100 - percent * 100}% 100%)`;
    comparisonAxis.style.left = `${100 - percent * 100}%`;
    if(comparisonInfoLeft.classList.contains('animate') || comparisonInfoRight.classList.contains('animate')) return;

    animDirections();
    comparisonInfoLeft.classList.add('animate');
    comparisonInfoRight.classList.add('animate');
  }

  function animDirections() {
    if(isMobile()) return;
    let percent = 1;
    let timer = setInterval(() => {
      percent ++;
      document.querySelectorAll('.comparison-info.left .comparison-direction').forEach((svg) => {
        svg.style.clipPath = `polygon(0 0, ${percent}% 0, ${percent}% 100%, 0 100%)`;
      })
      document.querySelectorAll('.comparison-info.right .comparison-direction').forEach((svg) => {
        svg.style.clipPath = `polygon(${100 - percent}% 0, 100% 0, 100% 100%, ${100 - percent}% 100%)`;
      })
      if(percent >= 100) {
        clearTimeout(timer);
      }
    }, 12);
  }
}

// Init bg cube animation

let window_scrollY = 0, temp_scrollY = 0;
const initBgCubeAnimation = () => {

  if(isMobile()) return;

  window_scrollY = window.scrollY;
  document.querySelectorAll('.bg-cube').forEach((bgCube) => {
    if(isScrolledIntoView(bgCube)) {
      let offset = parseFloat(bgCube.dataset.offset || 0);
      if(window_scrollY > temp_scrollY) {
        offset += 0.75;
      }
      else {
        offset -= 0.75;
      }
      bgCube.setAttribute('data-offset', offset);
      bgCube.style.marginTop = `${offset}px`;
    }
  })
  temp_scrollY = window_scrollY;
}

window.addEventListener('DOMContentLoaded', () => {
  initSectionAnimation();
  initComparisonSection();
})

document.addEventListener('scroll', (e) => {
  initSectionAnimation();
  initComparisonSection();
  initBgCubeAnimation();
})